// extracted by mini-css-extract-plugin
export default {"wrapper":"dnOVqT","headingsContainer":"eWwxLo","titleContainer":"L8Y_qB","subtitleContainer":"lDovXV","imageContainer":"vPAN2H","bowlImage":"zYG3H1"};